import { Drawer, Classes, AnchorButton } from "@blueprintjs/core";
import { useContext } from "react";
import { BuildNumberContext } from "psg-react-components";
import "./SettingsDrawer.scss";

type Props = {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function SettingDrawer({ open, setOpen }: Props) {
    const buildNumber = useContext(BuildNumberContext);
    return (
        <Drawer isOpen={open} size={"200px"} hasBackdrop={true} enforceFocus={false} title="Settings" icon={"settings"} onClose={() => setOpen(false)}>
            <div className="settings-drawer">
                <AnchorButton href="https://docs.amp.avanade.com/Automation/Process_Templates/AMP_Process_Templates/" icon="document" target="_blank">
                    Documentation
                </AnchorButton>
            </div>

            <div className={Classes.DRAWER_FOOTER}>
                <div className="build-version">
                    <div className="header">Process Templates Version</div>
                    {buildNumber}
                </div>
            </div>
        </Drawer>
    );
}

// if more toggles are required in the future this is the code
// <Card>
// <Switch key={"dark-mode-toggle"} label="Dark Mode" onChange={toggleTheme} />
//</Card>
//  {toggles.map(t => (
//     <Switch
//         key={t.setting}
//         checked={settings[t.setting] as boolean}
//         labelElement={t.label}
//         onChange={() => {
//             console.log("settings: ", settings);
//             setSettings(s => ({ ...s, [t.setting]: !s[t.setting] }));
//         }}
//     />
// ))}
// const toggles: {
//     setting: keyof Settings;
//     label: ReactNode;
// }[] = [
//     {
//         setting: "darkTheme",
//         label: (
//             <span>
//                 Dark theme
//                 {/* Hide <u>E</u>xternal */}
//             </span>
//         )
//     },
//     {
//         setting: "global",
//         label: (
//             <span>
//                 Global
//                 {/* Hide <u>E</u>xternal */}
//             </span>
//         )
//     }
// ];
